/**
 * The admin student/partner lists return TWO ids per row: `id` is the
 * student_profiles/partner_profiles row id, and `user_id` is the account.
 *
 * Account-level actions (delete, restore, purge) address the account, so they
 * must use `user_id`. Passing `id` silently targets whichever account happens
 * to share that number — deleting the wrong person.
 */
export function resolveAccountId(record: unknown): number | null {
  if (!record || typeof record !== "object") return null;

  const userId = (record as { user_id?: unknown }).user_id;
  if (typeof userId === "number" && Number.isFinite(userId) && userId > 0) return userId;
  if (typeof userId === "string" && /^\d+$/.test(userId)) return Number(userId);

  return null;
}
